import * as Dialog from '@radix-ui/react-dialog'
import { ExclamationTriangleIcon } from '@radix-ui/react-icons'
import { Repository } from '../utils/api-client/api-schemas.ts'
import { getRepositoryIcon } from '../utils/repository-utils'
import { DefaultButton } from './buttons/default-button.tsx'
import { GhostButton } from './buttons/ghost-button.tsx'
import * as styles from './delete-repository-dialog.css.ts'

export const DeleteRepositoryDialog: React.FC<{
  repository: {
    id: Repository['id']
    name: Repository['name']
    type: Repository['type']
  }
  handleDeleteRepository?: (repositoryId: string) => void
  handleCloseDeleteRepositoryDialog?: () => void
}> = ({ repository, handleDeleteRepository = () => {}, handleCloseDeleteRepositoryDialog = () => {} }) => {
  return (
    <Dialog.Root open={true}>
      <Dialog.Overlay className={styles.alertDialogOverlay} />
      <Dialog.Content className={styles.alertDialogContent}>
        <Dialog.Title className={styles.alertDialogTitle}>
          <ExclamationTriangleIcon className={styles.alertDialogIcon} />
          Delete repository?
        </Dialog.Title>
        <Dialog.Description className={styles.alertDialogDescription} asChild>
          <div>
            <p className={styles.alertDialogDescriptionParagraph}>
              You are about to delete the following repository, including its associated analysis data:
            </p>
            <p className={styles.alertDialogRepository}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {getRepositoryIcon({ type: repository.type })}
                {repository.name}
              </span>
            </p>
            <p className={styles.alertDialogDescriptionParagraph}>
              This action cannot be undone, and the data cannot be retrieved. Do you wish to proceed?
            </p>
          </div>
        </Dialog.Description>
        <div className={styles.alertDialogButtons}>
          <GhostButton type="secondary" onClick={handleCloseDeleteRepositoryDialog}>
            Cancel
          </GhostButton>
          <DefaultButton buttonType="destructive" onClick={() => handleDeleteRepository(repository.id)}>
            Delete repository
          </DefaultButton>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  )
}
